<div class="home-wrapper">
  <span class="loader"></span>
</div>

<!-- Der Okta-Benutzer gehoert zu mehreren Anwendungsbereichen (z. B. FAT und Messe-Demo) und waehlt die Datenbank selbst. -->
<clr-modal
  [(clrModalOpen)]="isDatabaseSelectVisible"
  [clrModalClosable]="false"
  [clrModalStaticBackdrop]="true"
  data-test-id="okta-database-selection-modal">
  <h3 class="modal-title">{{ 'Datenbank auswählen' | mrTranslate }}</h3>
  <div class="modal-body">
    <clr-select-container>
      <label>{{ 'Datenbank' | mrTranslate }}</label>
      <select clrSelect name="oktaDatabase" [(ngModel)]="selectedDatabase" data-test-id="okta-database-dropdown">
        @for (database of databaseChoices; track database.name) {
          <option [value]="database.name">{{ database.label }}</option>
        }
      </select>
    </clr-select-container>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline" (click)="cancelDatabaseSelection()">
      {{ 'Abbrechen' | mrTranslate }}
    </button>
    <button
      type="button"
      class="btn btn-primary"
      [disabled]="!selectedDatabase"
      (click)="confirmDatabaseSelection()"
      data-test-id="okta-database-selection-submit">
      {{ 'Weiter' | mrTranslate }}
    </button>
  </div>
</clr-modal>
